import { membersBaseURL } from "@/functions/helpers";

const baseURL = membersBaseURL();

const _post = (url, params) => window.axios.post(url, params, { baseURL });
const _put = (url, params) => window.axios.put(url, params, { baseURL });
const _delete = url => window.axios.delete(url, { baseURL });
const _get = url => window.axios.get(url, { baseURL });

export default {
  get(context, id) {
    return new Promise((resolve, reject) => {
      return _get(`/setup/config/${id}`)
        .then(response => {
          context.commit("setSetup", response.data);
          resolve(response);
        })
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      _post("/setup", params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/setup/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      _delete(`/setup/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  getFAQs(context, id) {
    return new Promise((resolve, reject) => {
      return _get(`/courses/faq/list/${id}?limit=999`)
        .then(response => {
          context.commit("setFaqs", response.data.results);
          resolve(response);
        })
        .catch(reject);
    });
  },
  getFAQ(context, id) {
    return new Promise((resolve, reject) => {
      return _get(`/courses/faq/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  postFAQ(context, params) {
    return new Promise((resolve, reject) => {
      _post(`/courses/faq/create`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  putFAQ(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/courses/faq/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  deleteFAQ(context, id) {
    return new Promise((resolve, reject) => {
      _delete(`/courses/faq/${id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
